import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function ArticleBody({ content }) {
    return (
        <motion.div {...fadeUp} className="max-w-3xl mx-auto px-6 lg:px-12" data-testid="article-body">
            {content.map((block) => (
                <div key={block.h || 'intro'} className="mb-10">
                    {block.h && (
                        <h2 className="font-montserrat font-bold text-2xl text-navy-900 mb-4 tracking-tight">{block.h}</h2>
                    )}
                    <div>
                        {block.ps.map((p) => (
                            <p key={p} className="text-[#4B5563] text-base leading-[1.8] mb-5 last:mb-0">{p}</p>
                        ))}
                    </div>
                </div>
            ))}
        </motion.div>
    );
}
